import axios from '@/libs/api.request'

export const getHrbusinessinfolist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/hrbusinessinfo/hrbusinessinfo/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationHrbusinessinfo = (data, meth) => {
  return axios.request({
    url: '/v1/hrbusinessinfo/hrbusinessinfo/',
    method: meth,
    data
  })
}
